import { createAction, props } from '@ngrx/store';
import { IUser } from '../../services/interface/user.interface';

// Autenticação
export const login = createAction('[Auth] Login', props<{ email: string; password: string }>());

export const loginSuccess = createAction('[Auth] Login Success', props<{ user: IUser; token: string }>());

export const loginFailure = createAction('[Auth] Login Failure', props<{ error: any }>());

export const logout = createAction('[Auth] Logout');

export const loadTokenFromStorage = createAction('[Auth] Load Token From Storage', props<{ user: IUser; token: string }>());
